import React from 'react';

import { StyledOcticon, Timeline } from '@primer/react';
import { WorkflowIcon } from '@primer/octicons-react';

import ClipboardLabel from '../common/ClipboardLabel/ClipboardLabel';
import CodeFormatLabel from '../common/Labels/CodeFormatLabel';
import LinkLabel from '../common/Labels/LinkLabel';

import { preserveWorkspaceURL } from '../../utils/url_utils';
import { truncateText } from '../../utils/text_utils';

const ModelAssociationItem = ({
  _modelID,
  modelVersion,
  pipelineID,
  pipelineVersion,
  condensed = false
}) => (
  <Timeline.Item className="text-brand items-center" condensed={condensed}>
    <Timeline.Badge>
      <StyledOcticon icon={WorkflowIcon} />
    </Timeline.Badge>
    <Timeline.Body>
      <div className="p-1 flex justify-between items-center">
        <div className="flex flex-col">
          <LinkLabel
            to={preserveWorkspaceURL(`/pipelines/${pipelineID}/versions/${pipelineVersion}`)}
            bold
          >
            {pipelineID}
          </LinkLabel>
          <div className="ml-1">
            Using Model {truncateText(modelVersion, 16)}...
          </div>
        </div>
        <div>
          <ClipboardLabel
            className="p-1"
            iconSize={16}
            labelValue={pipelineVersion}
            displayLabel={truncateText(pipelineVersion, 16)}
            LabelComponent={CodeFormatLabel}
            showClipboardIconOnHover
          />
        </div>
      </div>
    </Timeline.Body>
  </Timeline.Item>
);

export default ModelAssociationItem;
